<template>
	<div>This page is not used. backup taken by Jitendra</div>
</template>

<script>

export default {
	components: {

  },
  metaInfo: () => ({
    title: 'Shipping & Receiving',
  }),
	data() {
		return {

		};
	},
};
</script>